if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.slider = this.querySelector('.product-media-modal__content');
      this.prevButton = this.querySelector('[data-modal-prev]');
      this.nextButton = this.querySelector('[data-modal-next]');

      this.prevButton?.addEventListener('click', this.onPrevClick.bind(this));
      this.nextButton?.addEventListener('click', this.onNextClick.bind(this));
    }

    hide() {
      super.hide();
    }

    show(opener) {
      if (window.matchMedia("(max-width: 749px)").matches) return;
      super.show(opener);
      this.showActiveMedia();
    }

    onPrevClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.scrollSlider(-1);
    }

    onNextClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.scrollSlider(1);
    }

    getMediaItems() {
      return [...this.querySelectorAll('[data-media-id]')];
    }

    getCurrentIndex(items) {
      const activeIndex = items.findIndex((item) =>
        item.classList.contains('active')
      );

      if (activeIndex !== -1) return activeIndex;

      return items.findIndex((item) => {
        return Math.round(item.offsetLeft) === Math.round(this.slider.scrollLeft);
      });
    }

    updateArrowState() {
      const items = this.getMediaItems();
      const currentIndex = this.getCurrentIndex(items);

      if (this.prevButton) {
        this.prevButton.disabled = currentIndex <= 0;
      }

      if (this.nextButton) {
        this.nextButton.disabled = currentIndex >= items.length - 1;
      }
    }

    scrollSlider(direction) {
      if (!this.slider) return;

      const items = this.getMediaItems();
      if (!items.length) return;

      const currentIndex = this.getCurrentIndex(items);
      const nextIndex = Math.max(
        0,
        Math.min(items.length - 1, currentIndex + direction)
      );

      if (nextIndex === currentIndex) return;

      items[currentIndex]?.classList.remove('active');
      items[nextIndex]?.classList.add('active');

      this.scrollToItem(items[nextIndex]);
      this.updateArrowState();
    }

    scrollToItem(item, behavior = 'smooth') {
      if (!this.slider || !item) return;

      const left = Math.round(item.offsetLeft);

      this.slider.scrollTo({
        left,
        behavior
      });
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');

      this.scrollToItem(activeMedia, 'auto');
      // const container = this.querySelector('[role="document"]');
      // container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube')) {
        activeMedia.loadContent();
      }

      this.updateArrowState();
    }
  });
}
